import { useState, useEffect } from "react";
import axios from "axios";
import { CalendarClock } from "lucide-react";
import { API, authHeaders } from "./shared";

const BestSendTimeHint = () => {
  const [rec, setRec] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/best-send-time`, authHeaders())
      .then((r) => setRec(r.data))
      .catch(() => {});
  }, []);

  if (!rec) return null;

  return (
    <div data-testid="best-send-time-hint" className="flex items-start gap-2 border border-brand-gold/40 bg-brand-gold/10 px-3 py-2 mb-4">
      <CalendarClock size={14} className="text-brand-gold shrink-0 mt-0.5" />
      <div>
        <p className="font-sans text-xs text-brand-text">
          Best time to send: <span className="text-brand-gold font-semibold" data-testid="best-send-time-value">{rec.day} around {rec.time}</span>
          {!rec.data_based && <span className="text-brand-text-muted"> (general recommendation)</span>}
        </p>
        <p className="font-sans text-[10px] text-brand-text-muted mt-0.5">{rec.note} You always choose when to send — nothing goes out automatically.</p>
      </div>
    </div>
  );
};

export default BestSendTimeHint;
